import React, { useEffect, useState } from "react";
import Design1 from "../../Assets/home/DesignImage.png";
import Design2 from "../../Assets/home/DesignImage2.png";
import Avatar1 from "../../Assets/home/Avatar1.png";
import Avatar2 from "../../Assets/home/Avatar2.png";
import Avatar3 from "../../Assets/home/Avatar1.png";
import Quotation from "../../Assets/home/Quotation.png";
import axios from 'axios';

function WhatTheySay() {
  const [reviews, setReviews] = useState([]);
  const fetchReviews = async () => {
    let config = {
      method: "get",
      maxBodyLenght: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/reviews/fetchReviews?PLACE_ID=ChIJZRiFNjDnIDoRl4CElqS98PA&API_KEY=XYZ`,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response---->", response.data);
        setReviews(response.data);
      })
      .catch((error) => {
        console.log("Error in fetching reviews", error);
      });
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  
  return (
    <div
      className="grid grid-cols-[1fr_3fr_1fr] p-8 md:pr-2 bg-[#FFEFEA] mt-8"
      data-aos="flip-down"
    >
      <div>
        <img src={Design1} alt="Design Image" />
      </div>
      <div className="flex flex-col items-center justify-center">
        <p className="text-[#FF8F61] italic text-">Testimonials</p>
        <h1 className="text-[#202020] font-serif text-center mt-2 md:mt-4 font-extrabold text-3xl md:text-5xl">
          What They Say
        </h1>

        <div className="flex gap-4 md:gap-8 items-center justify-center p-8 pb-4">
          <img src={Avatar1} alt="An image of a person" className="w-12" />
          <img src={Avatar2} alt="An image of a person" />
          <img src={Avatar3} alt="An image of a person" className="w-12" />
        </div>

        <div className="flex flex-col justify-center items-center">
          <h1
            className="text-[#202020] font-serif text-center font-extrabold text-lg md:text-2xl"
            data-aos="zoom-in"
          >
            Taniya Jeet
          </h1>
          <p className="text-[#848383] mt-2 md:mt-4 text-sm">Business Owner</p>
        </div>

        <div className="flex items-center md:items-center pt-2">
          <p
            className="text-center text-xs md:text-lg font-serif"
            data-aos="zoom-in"
          >
            "I had an incredible experience at Kaya Spa. From the moment I
            walked in, the atmosphere was calm and soothing. The massage
            therapist was highly skilled and attentive to my needs, providing a
            perfect balance of relaxation and muscle relief. I left feeling
            refreshed, rejuvenated, and stress-free. The entire experience was
            pure bliss, and I can’t wait to return!"
            {/* {reviews.name}; */}
          </p>
        </div>
        <div className="p-8">
          <img
            src={Quotation}
            alt="Quotation Image"
            className="h-12 md:h-auto"
          />
        </div>

        <div className=""></div>
      </div>
      <div>
        <img src={Design2} alt="Design Image" />
      </div>
    </div>
  );
}

export default WhatTheySay;
